import script from "./forgot-password.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot-password.vue?vue&type=script&setup=true&lang=js"

import "./forgot-password.vue?vue&type=style&index=0&id=4138e244&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4138e244"]])

export default __exports__